import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MainRegisterView from './MainRegisterView';
import RecapRegisterView from './RecapRegisterView';


class RegisterView extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.passwordCallback = this.passwordCallback.bind(this);
    this.state = {
      registerData: {
        subscription: false,
        isAgree: false,
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        password: '',
      },
      errors: props.errors || {},
    };
  }

  static getDerivedStateFromProps(newProps) {
    return {
      errors: newProps.errors || {}
    }
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // Update register data
    const registerData = this.state.registerData;
    registerData[name] = value;

    // Clear error after dirty
    const errors = this.state.errors;
    errors[name] = null;

    this.setState({
      registerData: registerData,
      errors: errors,
    });
  }

  passwordCallback(data) {
    const registerData = this.state.registerData;
    registerData['password'] = data.password;

    const errors = this.state.errors;
    errors['password'] = null;

    this.setState({
      registerData: registerData,
      errors: errors,
    });
  }

  getDataUser() {
    const {registerData} = this.state;
    return {
      ...registerData
    };
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.action({
      ...this.getDataUser(),
    });
  }

  render() {
    const {inProgress, onCancel, recapPage, language} = this.props;
    const {registerData, errors} = this.state;
    const {handleSubmit, handleChange, passwordCallback} = this;
    if (recapPage) {
      return <RecapRegisterView
        inProgress={inProgress}
        errors={errors}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        passwordCallback={passwordCallback}
        registerData={registerData}
        language={language}
      />
    }
    return (
      <MainRegisterView
        inProgress={inProgress}
        errors={errors}
        registerData={registerData}
        onCancel={onCancel}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        passwordCallback={passwordCallback}
        language={language}
      />
    );
  }
}

RegisterView.propTypes = {
  errors: PropTypes.object,
  action: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  inProgress: PropTypes.bool
};

export default RegisterView;



// WEBPACK FOOTER //
// ./src/components/Customer/Auth/RegisterView.js